"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configurationDefaults = {
  apronBackSplash: {
    apron: {
      default: 'without',
      values: ['without', 'with'],
      allValues: ['without', 'with']
    },
    apronHeight: {
      default: 60,
      values: {
        min: 30,
        max: 150
      }
    },
    surgeEdgeOrBackSplash: {
      default: 'without',
      values: ['without', 'withSurgeEdge', 'withBackSplash'],
      allValues: ['without', 'withSurgeEdge', 'withBackSplash']
    },
    positionOfEdgeOrBacksplash: {
      default: null,
      values: ['left', 'right'],
      allValues: ['left', 'right']
    },
    backsplashHeight: {
      default: 10,
      values: {
        min: 10,
        max: 100
      }
    },
    restorablePlateDimensions: {
      default: null,
      values: null
    }
  },
  assemblyAccessories: {
    selection: {
      default: true,
      values: [true, false],
      allValues: [true, false]
    },
    console: {
      default: null,
      values: ['stainlessSteel', 'stainlessSteelWhite', 'miranit'],
      allValues: ['stainlessSteel', 'stainlessSteelWhite', 'miranit'],
      dimensions: {
        stainlessSteel: {
          min: 40,
          max: 40
        },
        stainlessSteelWhite: {
          min: 40,
          max: 40
        },
        miranit: {
          min: 170,
          max: 170
        }
      }
    },
    acceptedMiranitOverlap: {
      default: false,
      values: [false, true],
      allValues: [false, true]
    }
  },
  drainAccessories: {
    drain: {
      default: 'without',
      values: ['without', 'hood', 'sieve', 'eccentric'],
      allValues: ['without', 'hood-chrome', 'hood', 'sieve', 'eccentric']
    },
    siphon: {
      default: false,
      values: [false, true],
      allValues: [false, true]
    }
  },
  builtInParts: {
    tapHole: {
      default: false,
      values: [false, true],
      allValues: [false, true]
    },
    tapHolePositions: {
      default: null,
      isDrillHoleAllowed: [],
      isEnabled: [],
      values: []
    },
    soapDispenserHole: {
      default: 'without',
      values: ['without', 'SD80', 'others'],
      allValues: ['without', 'SD80', 'others']
    },
    soapDispenserHolePositions: {
      default: null,
      isDrillHoleAllowed: [],
      isEnabled: [],
      values: []
    },
    cutOutDisposals: {
      default: false,
      values: [false, true],
      allValues: [false, true]
    },
    cutOutDisposalsPosition: {
      default: null,
      values: [],
      isEnabled: [],
      spacings: [],
      distances: []
    },
    paperTowelDispensers: {
      default: false,
      values: [false, true],
      allValues: [false, true]
    },
    paperTowelDispensersPosition: {
      default: null,
      values: [],
      isEnabled: [],
      spacings: [],
      distances: []
    },
    withCutOutDisposals: {
      default: false,
      values: [false, true],
      allValues: [false, true]
    },
    cutOutDisposalsApronRequired: {
      default: true,
      values: [false, true],
      allValues: [false, true]
    },
    withCutOutDisposalsPosition: {
      default: null,
      values: []
    },
    cutOutDisposalsType: {
      default: null,
      values: ['CUSTOM_ROUND', 'CUSTOM_SQUARE', 'ROUND_SLEEVE', 'SQUARE_SLEEVE', 'ROUND_BASKET', 'ROUND_RAIL', 'SQUARE_BASKET', 'SQUARE_RAIL', 'ROUND_SLEEVE_BASKET', 'ROUND_SLEEVE_RAIL', 'SQUARE_SLEEVE_BASKET', 'SQUARE_SLEEVE_RAIL', 'FLAP', 'FLAP_BASKET', 'FLAP_RAIL'],
      allValues: ['CUSTOM_ROUND', 'CUSTOM_SQUARE', 'ROUND_SLEEVE', 'SQUARE_SLEEVE', 'ROUND_BASKET', 'ROUND_RAIL', 'SQUARE_BASKET', 'SQUARE_RAIL', 'ROUND_SLEEVE_BASKET', 'ROUND_SLEEVE_RAIL', 'SQUARE_SLEEVE_BASKET', 'SQUARE_SLEEVE_RAIL', 'FLAP', 'FLAP_BASKET', 'FLAP_RAIL'],
      spec: null
    },
    cutOutDisposalsCustomSettings: {
      default: null,
      values: null
    },
    // cutOutDisposalCustomType: {
    //   default: null,
    //   values: ['square', 'round'],
    //   allValues: ['square', 'round']
    // },
    // cutOutDisposalCustomWidth: {
    //   default: null,
    //   values: [],
    // },
    withTissueDispenser: {
      default: false,
      values: [false, true],
      allValues: [false, true]
    },
    withTissueDispenserPosition: {
      default: null,
      values: []
    },
    tissueDispenser: {
      default: false,
      values: [false, true],
      allValues: [false, true]
    },
    tissueDispenserPosition: {
      default: null,
      isEnabled: [],
      values: [],
      spacings: [],
      distances: []
    },
    towelRail: {
      default: false,
      values: [false, true],
      allValues: [false, true]
    },
    towelRailPosition: {
      default: null,
      values: []
    }
  },
  selectedTrough: {
    qty: 1,
    troughId: undefined
  },
  surface: {
    color: {
      default: 'white',
      values: ['white', 'black', 'black-white', 'light-gray'],
      allValues: ['white', 'black', 'black-white', 'light-gray']
    },
    gelCoat: {
      default: false,
      values: [true, false],
      allValues: [true, false]
    }
  },
  washBasinDimension: {
    typeOfInstallation: {
      default: 'without',
      values: ['without', 'left', 'with', 'right'],
      allValues: ['without', 'left', 'with', 'right']
    },
    angleOfNiche: {
      default: null,
      values: {
        min: 88,
        max: 92
      }
    },
    cornerDesign: {
      default: 'none',
      values: ['none', 'radius', 'bevel'],
      allValues: ['none', 'radius', 'bevel']
    },
    cornerDesignPosition: {
      default: null,
      values: ['left', 'right'],
      allValues: ['left', 'right']
    },
    plateThickness: {
      default: 0,
      current: 25,
      values: {
        min: 25,
        max: 25
      }
    },
    plateWidth: {
      default: 0,
      current: 550,
      values: {
        min: 200,
        max: 3600
      }
    },
    plateDepth: {
      default: 490,
      current: 490,
      values: {
        min: 400,
        max: 600
      }
    },
    distances: {
      default: null,
      values: []
    },
    plateDimensionsAcceptedNicheTip: {
      default: true,
      values: [true, false]
    }
  }
};
exports.defaults = exports.configurationDefaults;
exports.default = exports.defaults;